<template>
  <div class="new-content news-list2">
    <ul class="list" v-if="!_.isEmpty(dataSet.result)">
      <li v-for="(item, index) in dataSet.result" :key="`news-list-${index}`" :class="{plaintext: _.isEmpty(item.coverImage)}" @click="$router.push({name: 'RcepShow', params: {id: item.id}})">
        <template v-if="item.smallCoverImage">
          <div class="hasImg">
            <div class="imgWrap" :style="{background: `url(${item.smallCoverImage}) 0 0 no-repeat transparent`, 'background-size': 'cover'}"></div>
            <div class="content">
              <p :class="['title', 'ellipsis', { hotes: item.tags && item.tags.length > 0 }]">
                <span>{{item.title | removeTag(' ')}}</span>
                <b class="date">{{item.publishTime | dataFormat('dateTime.short2')}}</b>
              </p>
              <LineClamp class="desc" :msg="item.content | removeTag(' ')" :line="2" :isHtml="true" v-once></LineClamp>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="content">
            <p :class="['title', 'ellipsis', { hotes: item.tags && item.tags.length > 0 }]">
              <span>{{item.title | removeTag(' ')}}</span>
              <b class="date">{{item.publishTime | dataFormat('dateTime.short2')}}</b>
            </p>
            <LineClamp class="desc" :msg="item.content | removeTag(' ')" :line="2" :isHtml="true" v-once></LineClamp>
          </div>
        </template>
      </li>
    </ul>
    <div class="nodata" v-else-if="!isShowLoader && _.isEmpty(dataSet.result)">{{$t('common.noResult')}}</div>
    <Page :total="dataSet.count" show-total show-elevator :page-size="pageSize" :current.sync="currentPage" size="small" @on-change="goPager" v-if="dataSet.count > pageSize"></Page>
    <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-55px;"></Loader>
  </div>
</template>

<script>
import LineClamp from '@/components/common/LineClamp'
import Loader from '../layout/Loader'

export default {
  name: 'RcepListContent',
  components: { LineClamp, Loader },
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    pageSize: {
      type: Number
    },
    isShowLoader: {
      type: Boolean
    }
  },
  data () {
    return {
      currentPage: 1
    }
  },
  methods: {
    goPager (page) {
      this.$parent.getData(page)
    }
  }
}
</script>
<style scoped>
  .new-content >>> .ivu-page{
    text-align: center;
    padding: 50px 0 15px;
  }
  .new-content >>> .ivu-page a{
    font-size: 16px;
  }
  .new-content >>> .ivu-page-total,
  .new-content >>> .ivu-page-options-elevator,
  .new-content >>> .ivu-page-options-elevator input{
    font-size: 15px;
    color: #777;
  }
  .new-content >>> .ivu-page-item-active{
    background-color: #0470e3;
    border-color: #0470e3;
  }
  .list li{
    position: relative;
    padding-right: 5px;
    padding-bottom: 20px;
    padding-top: 25px;
    border-bottom: 0.5px solid #E9E9E9;
  }
  .list li .hasImg{
    position: relative;
    padding-left: 140px;
    margin-bottom: 10px;
  }
  .list li .hasImg .imgWrap{
    width: 120px;
    height: 90px;
    position: absolute;
    top: 0px;
    left: 0;
  }
  .list li.plaintext{
    padding-top: 18px;
    padding-bottom: 25px;
  }
  .list li:first-child{
    padding-top: 0;
  }
  .list li:first-child .cover{
    top: 0;
    display: block;
    transform: translateY(0);
  }
  .list li:last-child{
    padding-bottom: 10px;
    border-bottom: 0;
  }
  .list li .cover{
    width: 210px;
    position: absolute;
    top: 25px;
    left: 0;
    top:50%;
    transform: translateY(-50%);
  }
  .list li .cover:hover{
    text-decoration: none;
    box-shadow: none;
  }
  .list li .cover:after{
    width:0;
    height:0;
  }
  .list li .cover img{
    width: 100%;
    height: auto;
  }
  .list li .content{
    padding-top: 5px;
    cursor: pointer;
  }
  .list li.plaintext{
    padding-left: 0;
  }
  .list li.plaintext .content{
    min-height: 0;
    padding-top: 0;
  }
  .list li .content .title span:hover{
    color: #0470e3;
  }
  .list li .title{
    margin-bottom: 10px;
    padding-right: 160px;
    position: relative;
  }
  .list li .title.hotes{
    position: relative;
  }
  .list li .title .hot{
    border: 0.5px solid #2681FF;
    border-radius: 2px;
    color: #1F8AFD;
    font-size: 10px;
    padding: 0 3px;
    position: relative;
    top: -1px;
  }
  .list li .title.hotes a{
    padding-left: 5px;
  }
  .list li .title span{
    color: #333;
    font-size: 1.6rem;
    line-height: 24px;
  }
  .list li .date{
    color: #999;
    font-size: 13px;
    font-weight: normal;
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    right: 0;
  }
  .list li .desc{
    font-size: 1.5rem;
    line-height: 24px;
    color: #666;
  }
  .nodata{
    text-align: center;
    padding-top: 30px;
    font-size: 16px;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/news2/ListContent.vue